module.exports = __webpack_public_path__ + "static/media/Renae Geraci.5bb80eba.png";